import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  Box,
  Typography,
  alpha,
  useTheme
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import { useStore } from '../../../../stores/store';

const DeliveryTypeSelector: React.FC = observer(() => {
  const theme = useTheme();
  const { commonStore, userStore } = useStore();
  const { isDirectDelivery, setIsDirectDelivery } = commonStore;

  const roleName = userStore.user?.data?.admin?.role?.roleName || commonStore.user?.data?.admin?.role?.roleName || "";
  const isSuperKam = roleName === "Super KAM";

  const handleToggle = () => {
    // Resetting to null triggers the modal in DashboardLayout
    setIsDirectDelivery(null);
  };

  if (isDirectDelivery === null || isSuperKam) return null;

  return (
    <Box
      onClick={handleToggle}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        px: 2,
        py: 0.5,
        borderRadius: 2,
        bgcolor: isDirectDelivery 
          ? alpha(theme.palette.warning.main, 0.1) 
          : alpha(theme.palette.primary.main, 0.1),
        border: `1px solid ${isDirectDelivery 
          ? alpha(theme.palette.warning.main, 0.3) 
          : alpha(theme.palette.primary.main, 0.3)}`,
        transition: 'all 0.2s',
        '&:hover': {
          bgcolor: isDirectDelivery 
            ? alpha(theme.palette.warning.main, 0.2) 
            : alpha(theme.palette.primary.main, 0.2),
          transform: 'translateY(-1px)',
          boxShadow: theme.shadows[1]
        },
        mx: 2
      }}
    >
      {isDirectDelivery ? (
        <FlashOnIcon sx={{ color: theme.palette.warning.main, mr: 1, fontSize: 18 }} />
      ) : (
        <LocalShippingIcon sx={{ color: theme.palette.primary.main, mr: 1, fontSize: 18 }} />
      )}
      <Typography
        variant="subtitle2"
        fontWeight={700}
        sx={{
          color: isDirectDelivery ? theme.palette.warning.dark : theme.palette.primary.dark,
          whiteSpace: 'nowrap'
        }}
      >
        {isDirectDelivery ? 'Direct Delivery' : 'Normal Delivery'}
      </Typography>
    </Box>
  );
});

export default DeliveryTypeSelector;
